jQuery(function() {
	jQuery('.person-info .name-title').matchHeight();

	jQuery('.numbers .number .number-title').matchHeight();
	jQuery('.numbers .number .icon-wrap').matchHeight();
});